import React from 'react';
import './confirmModal.css';

export type ConfirmModalProps = {
  open: boolean;
  title: string;
  children?: React.ReactNode;
  cancelLabel?: string;
  confirmLabel?: string;
  /** busy 为 true 时主按钮展示此文案，未传则用「{confirmLabel}…」 */
  confirmBusyLabel?: string;
  confirmVariant?: 'danger' | 'primary';
  busy?: boolean;
  onCancel: () => void;
  /** 可返回 Promise（如异步删除） */
  onConfirm: () => void | Promise<void>;
};

/** 通用确认弹窗。样式跟随组件目录维护，避免依赖具体业务页面 CSS。 */
export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  title,
  children,
  cancelLabel = '取消',
  confirmLabel = '确定',
  confirmBusyLabel,
  confirmVariant = 'primary',
  busy = false,
  onCancel,
  onConfirm,
}) => {
  const titleId = React.useId();
  const confirmBtnClass = confirmVariant === 'danger' ? 'btn danger' : 'btn primary';
  const confirmText = busy ? confirmBusyLabel ?? `${confirmLabel}…` : confirmLabel;

  return (
    <div className={`confirm-modal-mask${open ? '' : ' hidden'}`}>
      <div
        className="confirm-modal-box"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
      >
        <button
          type="button"
          className="confirm-modal-close"
          onClick={onCancel}
          aria-label="关闭"
          disabled={busy}
        >
          ×
        </button>
        <h3 id={titleId}>{title}</h3>
        {children != null ? <div className="confirm-modal-body">{children}</div> : null}
        <div className="confirm-modal-actions">
          <button type="button" className="btn" disabled={busy} onClick={onCancel}>
            {cancelLabel}
          </button>
          <button
            type="button"
            className={confirmBtnClass}
            disabled={busy}
            onClick={() => void onConfirm()}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};
